// extracted by mini-css-extract-plugin
module.exports = {"container":"_5GEq0YfLXW_Tdpj9kHpNq","item":"_2dWW-3DwDx54yYBeEquT1w","dot":"_2ZBXB7Tq_aYnPQoP0JBFu4"};